import * as angular from "angular";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { ChartHelper } from "../result/chart.helper";
import { DialogUtils } from "../../helper/dialog.helper";

let SurveyResultsComponent = {
    selector: "vcSurveyResults",
    templateUrl: "/angular/components/survey/survey-results.component.html",
    bindings: {
        type: "=",
        survey: "=",
        canvassType: "=",
        loading: "=?",
    },
    controller: class SurveyResultsController {
        // * bindings for typescript compiler *
        public type: any;
        public survey: any;
        public canvassType: any;
        public loading: any;
        // ************************************

        private readonly $scope: any;
        private readonly $mdMedia: any;
        public __env: any;
        private dialog: DialogUtils;
        public navigationBarService: NavigationBarHelperService;

        public chartColors: any;
        public pieOptions: any;
        public barOptions: any;
        public showCharts = false;

        constructor(
            $scope: any,
            $mdMedia: any,
            ChartHelper: ChartHelper,
            NavigationBarHelperService: NavigationBarHelperService,
            __env: any,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.$mdMedia = $mdMedia;
            this.dialog = DialogUtils;
            this.__env = __env;
            this.navigationBarService = NavigationBarHelperService;

            this.chartColors = ChartHelper.chartColors;
            this.pieOptions = ChartHelper.pieOptions;
            this.barOptions = ChartHelper.barOptions;
            this.barOptions.chart.xAxis.tickFormat = "";
            this.barOptions.chart.margin = {
                top: 20,
                right: 30,
                bottom: 20,
                left: 30,
            };
        }

        $onInit() {
            this.$scope.$watch(
                () => this.survey,
                () => (this.showCharts = false),
                true
            );

            this.$scope.$watch(
                () => this.canvassType,
                () => (this.showCharts = false),
                true
            );
        }

        setShowCharts(): void {
            //Only allow charts to be drawn after questions are loaded and grid list has been drawn.
            if (this.survey.questions.length) {
                this.showCharts = true;
            }
        }

        givenAnswersDialog(question: object, ev: object): void {
            this.dialog.show({
                component: "vc-survey-answers",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    question: question,
                },
            });
        }

        getNumCols(): number {
            if (this.type == "partial" || this.$mdMedia("xs")) {
                return 1;
            } else if (this.$mdMedia("sm") || this.$mdMedia("md")) {
                return 2;
            } else {
                return 3;
            }
        }

        openViewHouseOccupantDialog(hoid: string | number, ev: object): void {
            this.dialog.show({
                component: "vc-view-house-occupant",
                targetEvent: ev,
                scope: this.$scope,
                skipHide: true,
                clickOutsideToClose: true,
                locals: {
                    selectedHoid: hoid,
                },
                ariaLabel: "View Person",
                size: "large",
            });
        }

        calculateRowSpan(question: any): number {
            if (question.total == 0) return 12;
            let additionalQuestionHeight: number;
            if (question.sqname.length <= 300) {
                additionalQuestionHeight = additionalQuestionHeight =
                    question.sqname.length > 80 ? 3 : 0;
            } else {
                additionalQuestionHeight = 4;
            }

            let answers =
                question.atid == 3 ? question.given_answers : question.choices;

            if (question.atid == 3) {
                return !question.expand || answers < 6 ? 10 : 20;
            }

            let answersHeight: number;
            if (answers.length > 10) {
                answersHeight = !question.expand ? 10 : 11;
            } else {
                answersHeight = answers.length;
            }

            let chartHeight = question.atid == 5 ? 10 : 8;
            return chartHeight + answersHeight + additionalQuestionHeight;
        }

        openViewHouseDialog(hid: string | number, ev: object): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: hid,
                    selectedHouse: null,
                },
            });
        }
    },
};

angular
    .module("survey")
    .component(SurveyResultsComponent.selector, SurveyResultsComponent);
